/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CatalogTaskResponseContent
 */
export interface CatalogTaskResponseContent {
    /**
     * Human-readable confirmation message.
     * @type {string}
     * @memberof CatalogTaskResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the CatalogTaskResponseContent interface.
 */
export function instanceOfCatalogTaskResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function CatalogTaskResponseContentFromJSON(json: any): CatalogTaskResponseContent {
    return CatalogTaskResponseContentFromJSONTyped(json, false);
}

export function CatalogTaskResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogTaskResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function CatalogTaskResponseContentToJSON(value?: CatalogTaskResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

